export const refundCategoryType = {
  nonRefundable: "non_refundable",
  partialRefundable: "partial_refundable",
  refundable: "fully_refundable",
};
